// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ncaLr","addWidgetButton":"Header_addWidgetButton__21B8H","dashboardTabs":"Header_dashboardTabs__14O0k","active":"Header_active__1t7Eq"};